import React from 'react'
import { render } from 'react-dom'
import Root from './containers/Root'

import './_assets/css/bootstrap.min.css'
import './_assets/css/index.css'
import './_assets/css/react-redux-toastr.min.css'

render(
  <Root />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js